import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Guest Traffic Tracking Hook
 * Tracks page visits for non-logged-in users (UTM, ref codes)
 * Silent - wirft KEINE Fehler in der Konsole!
 */
export default function useGuestTracking() {
  const location = useLocation();
  
  useEffect(() => {
    const token = localStorage.getItem('snapshot_token');
    const consent = localStorage.getItem('snapshot_consent');

    // Only track if NOT logged in AND user has given consent
    if (!token && consent === 'all') {
      const params = new URLSearchParams(location.search);
      
      const trackData = {
        page: location.pathname,
        utm_source: params.get('utm_source'),
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign'),
        ref: params.get('ref'),
        timestamp: new Date().toISOString()
      };
      
      // Silent fetch - KEIN Error wenn Route nicht existiert
      fetch('/api/analytics/guest-visit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(trackData)
      }).catch(() => {}); // Silent fail - keine Console Errors!
    }
  }, [location.pathname, location.search]);
}
